"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var Riot = function Riot(props) {
  var color = props.color,
      size = props.size,
      others = _objectWithoutPropertiesLoose(props, ["color", "size"]);

  return _react.default.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    fill: color,
    viewBox: "0 0 24 24"
  }, others), _react.default.createElement("path", {
    d: "M5.918 0c-2.067 0-3.76 1.623-3.76 3.63-.003 5.526.001 11.483 0 16.743 0 2.006 1.693 3.627 3.76 3.627 2.067 0 3.762-1.62 3.762-3.627v-3.071l1.984-.002 3.63 4.98c.673.924 1.746 1.419 2.836 1.419.686 0 1.378-.196 1.983-.603 1.564-1.054 1.943-3.13.846-4.635l-2.322-3.19c1.97-1.593 3.224-3.977 3.224-6.621 0-4.773-4.037-8.65-8.98-8.65zm1.42.603h5.543c4.63 0 8.38 3.613 8.38 8.047 0 2.444-1.156 4.652-2.98 6.136l-1.648-2.263c1.078-.97 1.768-2.338 1.768-3.873 0-2.942-2.48-5.322-5.52-5.322H9.367a3.215 3.215 0 0 0-.597-1.606A3.405 3.405 0 0 0 7.338.602zM9.365 3.93h3.516c2.727 0 4.919 2.115 4.919 4.719 0 1.335-.588 2.53-1.518 3.39l-.211-.29a3.463 3.463 0 0 0-2.2-1.36c.636-.34 1.071-.992 1.071-1.74 0-1.103-.933-1.994-2.061-1.994H9.079v3.992l2.706-.002a3.28 3.28 0 0 0-1.979 2.727l-3.587.004V6.93a3.515 3.515 0 0 0 1.7-.575 3.296 3.296 0 0 0 1.425-2.148c.017-.092.012-.184.02-.276zM2.759 4.959c.092.201.204.394.338.578.606.833 1.543 1.303 2.522 1.39v13.446c-.02.42.62.42.6 0v-6.395l3.59-.004c.054.555.238 1.106.594 1.595l.824 1.13-2.148.002v3.672c0 1.669-1.406 3.026-3.161 3.026-1.754 0-3.16-1.357-3.16-3.026-.002-5.124 0-10.7 0-15.414zm6.92 2.298h3.202c.814 0 1.459.629 1.459 1.393 0 .725-.588 1.34-1.357 1.39a1.595 1.595 0 0 1-.106.003l-3.197.002Z"
  }));
};

Riot.propTypes = {
  /**
   * Hex color or color name
   */
  color: _propTypes.default.string,

  /**
   * The size of the Icon.
   */
  size: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])
};
Riot.defaultProps = {
  color: 'currentColor',
  size: '24'
};
var _default = Riot;
exports.default = _default;